import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { 
  IoSettings as Settings,
  IoCaretBackOutline as CaretBackOutline,
  IoCaretForwardOutline as CaretForwardOutline, 
  IoTrendingUp as TrendingUp,
  IoPricetag as Pricetag, 
  IoShareSocial as ShareSocial
} from 'react-icons/io5';
import Menu from 'react-burger-menu/lib/menus/slide'
import { NavLink } from 'react-router-dom';

export const MenuLeft = (props) => {
  const { t } = useTranslation('layout');
  const [ topClass, setTopClass ] = useState("left-menu-container");
  const handleToggle = () => {
    if (props.opened) props.setOpened(false);
    else props.setOpened(true);
  };

  const handleResize = () => {
    if (props.expanded && window.innerWidth > 768 && window.innerWidth < 991) {
      if (props.user) {
        setTopClass("left-menu-container menu-top-lg-expanded");
      } else {
        setTopClass("left-menu-container menu-top-lg-expanded-nouser");
      }            
    } else if (props.expanded && window.innerWidth < 768) {
      if (props.user) {
        setTopClass("left-menu-container menu-top-expanded");
      } else {
        setTopClass("left-menu-container menu-top-expanded-nouser");
      }       
    } else {
      setTopClass("left-menu-container");
    }
  }

  useEffect(() => {
    handleResize();
  }, [props.expanded, props.user]);// eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    window.addEventListener("resize", handleResize);
  }, []);// eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className={topClass}>
      { props.user &&
        <>
          <div className="left-menu-container">
            <div className="left-menu-button-container bg-light">
              <div className="left-menu-button">            
                { props.opened ?
                  <span className="link">
                    <CaretBackOutline color={'#ffffff'} title={t('my-menu')} height="36px" width="36px" onClick={() => handleToggle()}/>
                  </span>
                :
                  <span className="link">
                    <CaretForwardOutline  color={'#ffffff'} title={t('my-menu')} height="36px" width="36px" onClick={() => handleToggle()}/>
                  </span>
                }
              </div>
            </div> 
            <Menu 
              isOpen={props.user?props.opened:false}
              noOverlay 
              customBurgerIcon={false}
              customCrossIcon={false}  
            >          
              <NavLink className="bm-item menu-item" to={(props.user.subscription)?"/account":"/subscribe"}>
                <span className="link">
                  <Settings color='#ffffff' title={t('accounts')} height="25px" width="25px"/>         
                </span>
                &nbsp; {t('accounts')}
              </NavLink>
              <NavLink className="bm-item menu-item" to={(props.user.subscription)?"/projections":"/subscribe"}>
                <span className="link">
                  <TrendingUp color='#ffffff' title={t('projections')} height="25px" width="25px"/>
                </span>
                &nbsp; {t('projections')}
              </NavLink>             
              <NavLink className="bm-item menu-item" to={(props.user.subscription)?"/budget":"/subscribe"}>
                <span className="link">
                  <Pricetag color='#ffffff' title={t('budget')} height="25px" width="25px"/>
                </span>
                &nbsp; {t('budget')}
              </NavLink>
              <NavLink className="bm-item menu-item" to="/shares">
                <span className="link">
                  <ShareSocial color='#ffffff' title={t('shares')} height="25px" width="25px"/>
                </span>
                &nbsp; {t('shares')}
              </NavLink>                                    
          </Menu>
        </div>
      </>
      }
    </div>
  )
};